function normalizePromptText(value: string): string {
  return value.trim();
}

export function composePromptFragment(basePromptFragment: string): string {
  return normalizePromptText(basePromptFragment);
}
